import React, {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import {Form, Button, message, Skeleton, Row} from 'antd';
import {cerrarNomina} from '../../../../apis/ProcesoNominaApi';
import {emit} from '../../../../apis/TimbradoApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import {status_period} from '@app/constants/period';
import _ from 'lodash'
import Result from './result'

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Cierre de Nómina</span>
      </>
    ),
  }];

const CierreNomina = () => {
    const [ form ] = Form.useForm()
    const [ loading, setLoading ] = useState(false);
    const [objectSelected, setObjectSelected] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [header, setHeader] = useState(null);  
    const [period, setPeriod] = useState(null);  

    const handleOk = async ({concepto}) => {
      setLoading(true);
      let success = false;
      const fields = form.getFieldsValue();
      const payload = {
          ...fields
      }
      const response = await cerrarNomina(payload);
      success = response.ok;
      if(response.ok){
          // setID(response.payload);
          message.success('Se proceso correctamente la nomina!');
      }
      if(success){
        window.location.reload();
      }
      setLoading(false);
    }

    const resetBody = async ()=>{
      let values = await form.getFieldValue();
      form.resetFields();
      form.setFieldsValue({
        periodo_id: values.periodo_id,
        anio: values.anio,
        num_periodo: values.num_periodo,
      });
    }

    const onBlurHeader = async (values, period)=> {
      setHeader(values)
      if(values?.anio && values?.num_periodo && values?.periodo_id){
        setDisabled(false);
      }else{
        setDisabled(true);
      }

      if(period){
        setPeriod(period);
      }else{
        setPeriod(null)
      }
    }

    return <PageApp 
      routes={routes}
      title={'Cierre de Nómina'}>
        <AnioPeriodo onBlur={onBlurHeader} form={form} disabledForm={objectSelected && objectSelected.id > 0}/>
        <Row>
          <Button type="primary" onClick={handleOk} loading={loading} disabled={!period || period.status !== status_period.calculado_total}>
            {loading ? 'Procesando': 'Cerrar Nomina'}
          </Button>

          {/* <Button style={{marginLeft: 10}} type="primary" onClick={handleTimbrarOk} loading={loading}>
            {loading ? 'Procesando': 'Timbrar Nomina'}
          </Button> */}          
        </Row>
        <br/>
        {
          loading ? <Skeleton active={loading} />: <>
            {
              header && !disabledForm && (loading ? <Skeleton active={loading} /> : <Result header={header} />)
            }
          </>
        }

    </PageApp>
}   

export default CierreNomina;
